export default [
    // monthly installment table data
    {
        customer_assets:[
            {
                kyc_data_id: 3,
                customer_id: 3075,
                customer_form_id: 1,
                customer_template_category: {
                    customer_category_id: 1,
                    customer_category_name: "Assets",
                    customer_sub_category_id: 1,
                    customer_sub_category_name: "Cash / Cash Equivalents",
                    customer_category_sort: 0,
                    customer_sub_category_sort: 0,
                },
                frequency_id: 2,
                frequency_name: 'Annually',
                customer_question_id: 56,
                customer_question_column: "Savings Account",
                answer: {
                    answer_id: 54,
                    customer_value: 250.00,
                    customer_month_value:50.00,
                    customer_annual_value:50.00 * 12,
                    admin_value: 550.50,
                    admin_month_value:null,
                    admin_annual_value:null,    
                },
                remark: '',
            },
            {
                kyc_data_id: 4,
                customer_id: 3075,
                customer_form_id: 1,
                customer_template_category: {
                    customer_category_id: 1,
                    customer_category_name: "Assets",
                    customer_sub_category_id: 1,
                    customer_sub_category_name: "Investment Assets",
                    customer_category_sort: 0,
                    customer_sub_category_sort: 1,
                },
                frequency_id: 2,
                frequency_name: 'Annually',
                customer_question_id: 57,
                customer_question_column: "EPF",
                answer: {
                    answer_id: 55,
                    customer_value: 1000.00,
                    customer_month_value:50.00,
                    customer_annual_value:50.00 * 12,
                    admin_value: 500,
                    admin_month_value:null,
                    admin_annual_value:null,                
                },
                remark: '',
            },
            {
                kyc_data_id: 4,
                customer_id: 3075,
                customer_form_id: 1,
                customer_template_category: {
                    customer_category_id: 1,
                    customer_category_name: "Assets",
                    customer_sub_category_id: 1,
                    customer_sub_category_name: "Investment Assets",
                    customer_category_sort: 0,
                    customer_sub_category_sort: 1,
                },
                frequency_id: 2,
                frequency_name: 'Annually',
                customer_question_id: 58,
                customer_question_column: "Islamic Unit Trust",
                answer: {
                    answer_id: 56,
                    customer_value: 1000.00,
                    customer_month_value:50.00,
                    customer_annual_value:50.00 * 12,
                    admin_value: null,
                    admin_month_value:null,
                    admin_annual_value:null,
                },
                remark: '',
            },
            {
                kyc_data_id: 5,
                customer_id: 3075,
                customer_form_id: 1,
                customer_template_category: {
                    customer_category_id: 1,
                    customer_category_name: "Assets",
                    customer_sub_category_id: 1,
                    customer_sub_category_name: "Personal Use Assets",
                    customer_category_sort: 0,
                    customer_sub_category_sort: 2,
                },
                frequency_id: 2,
                frequency_name: 'Annually',
                customer_question_id: 59,
                customer_question_column: "Personal Residential Home (Market Value)",
                answer: {
                    answer_id: 57,
                    customer_value: 250.00,
                    customer_month_value:50.00,
                    customer_annual_value:50.00 * 12,
                    admin_value: 300,
                    admin_month_value:null,
                    admin_annual_value:null, 
                },
                remark: '',
            },
            {
                kyc_data_id: 6,
                customer_id: 3075,
                customer_form_id: 1,
                customer_template_category: {
                    customer_category_id: 1,
                    customer_category_name: "Assets",
                    customer_sub_category_id: 1,
                    customer_sub_category_name: "Personal Use Assets",
                    customer_category_sort: 0,
                    customer_sub_category_sort: 2,
                },
                frequency_id: 2,
                frequency_name: 'Annually',
                customer_question_id: 60,
                customer_question_column: "Cars (Current Market Value)",
                answer: {
                    answer_id: 58,
                    customer_value: 1200.00,
                    customer_month_value:50.00,
                    customer_annual_value:50.00 * 12,
                    admin_value: 1350,
                    admin_month_value:null,
                    admin_annual_value:null,  
                },
                remark: '',
            },
        ],
        total: {
            total_asset_customer_value: {
                "Cash / Cash Equivalents": 250,
                "Investment Assets": 2000,
                "Personal Use Assets": 1450,
            },
            total_asset: 3700
        },
    }
]